<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     触发器编辑
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    class="trigger-editer"
    :visible.sync="dialogShow"
    width="900px"
    :close-on-click-modal="false"
    :modal-append-to-body="false">
    <div slot="title">
      <span v-if="sen.sen_name" class="font-lg">{{ sen.sen_name }} | </span>
      <span class="font-lg mr">触发器</span>
      <el-button type="text" icon="el-icon-circle-plus-outline" @click="addRow()">新增一行</el-button>
    </div>

    <div v-loading="loading" style="min-height: 400px;">
      <el-table
        :data="triggers"
        :show-header="false"
        style="border-top: 1px solid #eee;">
        <el-table-column type="index" width="40" />

        <el-table-column>
          <template slot-scope="scope">
            <el-form :ref="'Form' + scope.row.idx || scope.row.triggerid" :inline="true" :model="scope.row" :rules="rules">
              <el-form-item prop="message">
                <el-input v-model="scope.row.message" placeholder="消息内容" style="width: 240px;" />
              </el-form-item>

              <el-form-item>
                <el-select v-model="scope.row.trigger_type" style="width: 220px;">
                  <el-option
                    v-for="item in triggerTypeArr"
                    :key="item.value"
                    :label="item.title"
                    :value="item.value" />
                </el-select>
              </el-form-item>

              <el-form-item v-if="showSec.indexOf(scope.row.trigger_type) > -1" prop="sec">
                <el-input v-model.number="scope.row.sec" placeholder="Sec" style="width: 80px;" type="number"/>
              </el-form-item>

              <el-form-item v-if="showMin.indexOf(scope.row.trigger_type) > -1" prop="min">
                <el-input v-model.number="scope.row.min" placeholder="Min" style="width: 80px;" type="number"/>
              </el-form-item>

              <el-form-item v-if="showMax.indexOf(scope.row.trigger_type) > -1" prop="max">
                <el-input v-model.number="scope.row.max" placeholder="Max" style="width: 80px;" type="number"/>
              </el-form-item>

              <el-form-item v-if="showValue.indexOf(scope.row.trigger_type) > -1" prop="min">
                <el-input v-if="sen.sen_type == 1" v-model.number="scope.row.min" placeholder="Value" style="width: 80px;" type="number"/>
                <el-select v-if="sen.sen_type == 2" v-model="scope.row.min" filterable>
                  <el-option
                    v-for="(value,key) in sen.field1"
                    :key="key"
                    :label="value"
                    :value="value"
                  />
                </el-select>
                <el-input v-if="sen.sen_type == 4" v-model="scope.row.min" placeholder="Value" style="width: 80px;" />
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column width="50" align="center">
          <template slot-scope="scope">
            <i role="button" class="el-icon-circle-close font-lg text-muted" @click="removeRow(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="text-center">
      <el-button class="extend" plain @click="dialogShow = false">取消</el-button>
      <el-button class="extend" type="primary" :loading="posting" @click="submit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSenApi } from '@/api/senApi'
import { postTriggerApi } from '@/api/triggerApi'
export default {
  name: 'TriggerEditer',

  props: {
    show: {
      type: [Boolean, Number],
      default: false
    },

    senid: {
      type: Number,
      default: undefined
    }
  },

  data() {
    return {
      loading: false,
      sen: {},
      triggers: [],

      rules: {
        message: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        sec: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        min: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        max: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      showSec: [7, 8, 9, 10, 11, 12],
      showMin: [2, 3, 4, 8, 9, 10, 13, 14],
      showMax: [1, 3, 4, 7, 9, 10, 13, 14],
      showValue: [15],

      posting: false,
    }
  },

  computed: {
    triggerTypeArr() {
      //如果trigger_sen是数值型，只能选择数值型触发条件
      if(this.sen.sen_type == 1) {
        return this.$store.state.commonStore.triggerTypeArr.filter(v => v.value != 5 && v.value != 6)
      }
      //如果trigger_sen是枚举型，只能选择枚举型触发条件
      if(this.sen.sen_type == 2) {
        return this.$store.state.commonStore.triggerTypeArr.filter(v => v.value == 15)
      }
      //如果trigger_sen是开关型，只能选择开关型触发条件
      if(this.sen.sen_type == 3) {
        return this.$store.state.commonStore.triggerTypeArr.filter(v => v.value == 5 || v.value == 6)
      }
      if(this.sen.sen_type == 4) {
        return this.$store.state.commonStore.triggerTypeArr.filter(v => v.value == 15)
      }
      return this.$store.state.commonStore.triggerTypeArr
    },   

    dialogShow: {
      get() {
        return !!this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      getSenApi({ senid: this.senid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.sen = Object.assign({}, res.data.sen)
          this.triggers = res.data.triggers
          if (!this.triggers.length) this.addRow()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    addRow() {
      let trigger_type = 1;
      if(this.sen.sen_type == 2) {
        trigger_type = 15;
      }
      if(this.sen.sen_type == 3) {
        trigger_type = 5;
      }
      if(this.sen.sen_type == 4) {
        trigger_type = 15;
      }
      this.triggers.push({
        idx: +new Date(),
        message: undefined,
        trigger_type,
        min: undefined,
        max: undefined,
        sec: undefined,
      })
    },
    removeRow(row) {
      this.triggers.splice(this.triggers.indexOf(row), 1)
    },

    submit() {
      let validCheck = true
      const formArr = Object.keys(this.$refs)
      for (var i = 0; i < formArr.length; i++) {
        if (this.$refs[formArr[i]] && formArr[i].indexOf('Form') === 0) {
          this.$refs[formArr[i]].validate((valid) => {
            if (!valid) {
              validCheck = false
            }
          })
        }
      }
      if (validCheck) {
        this.posting = true
        postTriggerApi({
          senid: this.senid,
          data: this.triggers
        }).then(res => {
          this.posting = false
          if (!res.errno) {
            this.dialogShow = false
            this.$message.success(res.message)
            this.$store.dispatch('fetchDataAction')
            this.$emit('submit', this.sen)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.trigger-editer {
  .el-form-item {
    margin-bottom: 0px;
  }
}
/deep/input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/* Firefox */
/deep/input[type='number']{
    -moz-appearance: textfield;
}
</style>
